export const DEFAULT_QTY = 10

export enum ChangeQtyType {
  AddMore = 'add_more',
  Plus = 'plus',
  Minus = 'minus',
}
